export const getTagIdArrayAsQueryParam = (tagIdArray = [], queryParamName = 'tags') => {
  return tagIdArray ? tagIdArray.reduce((acc, val) => `${acc}&${queryParamName}[]=${val}`, '') : '';
};
